import { Component, Input, OnChanges } from "@angular/core";
import { IDiagnosticTroubleCode } from "@app/main/modules/maintenance/_components/faultCodes/_models/IDiagnosticTroubleCode";
import "./reefer-error-list.component.scss";

@Component({
    selector: "reefer-error-list",
    template: require("./reefer-error-list.component.html")
})
export class ReeferErrorListComponent implements OnChanges {
    // Todo, move related logic into this component or into service
    @Input() diagnosticErrors: IDiagnosticTroubleCode[];

    constructor() {
    }

    ngOnChanges() {
    }
}
